import React from 'react';
import styles from './Graph.module.css';
import pagesStandardStyles from '../../../../Pages.module.css';
import InStoreAndEcomGraphs from './InStoreAndEcomGraphs';
import AceRewardsGraphs from './AceRewardsGraphs';
import BusinessToBusinessGraphs from './BusinessToBusinessGraphs';
import { useAppSelector } from '../../../../../redux/hooks';
import {
  selectOverallPerformanceData,
  selectOverallLoading,
} from '../../../../../redux/PerformanceReducer/Overall/overallSlice';
import SkeletonLineGraph from '../../../../../components/skeletons/performance/overall';
import lang from '../../../../../languages/en.json';

const GRAPH_SECTIONS = [
  {
    title: lang.lineGraph.InStoreEcomHeader,
    skeletonCount: 14,
    Component: InStoreAndEcomGraphs,
  },
  {
    title: lang.lineGraph.AceRewardsHeader,
    skeletonCount: 3,
    Component: AceRewardsGraphs,
  },
  {
    title: lang.lineGraph.B2BHeader,
    skeletonCount: 3,
    Component: BusinessToBusinessGraphs,
  },
] as const;

const Graph: React.FC = () => {
  // Access data directly from Redux - fetch is triggered by parent (Overall.tsx)
  const performanceData = useAppSelector(selectOverallPerformanceData);
  const isLoading = useAppSelector(selectOverallLoading);

  if (isLoading) {
    return (
      <div>
        {GRAPH_SECTIONS.map(section => (
          <React.Fragment key={section.title}>
            <h2 className={pagesStandardStyles.sectionHeader}>{section.title}</h2>
            <div className={styles.graphGrid}>
              <SkeletonLineGraph count={section.skeletonCount} />
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  }

  const errorMessage = lang.pageContent.dataUnavailableError.replace(
    '{section}',
    lang.lineGraph.graph,
  );
  if (performanceData == null) {
    return (
      <div className={pagesStandardStyles.errorContent}>
        <p>{errorMessage}</p>
      </div>
    );
  } else if (Object.keys(performanceData).length === 0) {
    return (
      <div className={pagesStandardStyles.errorContent}>
        <p>{lang.lineGraph.noData}</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className={pagesStandardStyles.sectionHeader}>{lang.lineGraph.InStoreEcomHeader}</h2>
      <div className={styles.graphGrid}>
        <InStoreAndEcomGraphs />
      </div>

      <h2 className={pagesStandardStyles.sectionHeader}>{lang.lineGraph.AceRewardsHeader}</h2>
      <div className={styles.graphGrid}>
        <AceRewardsGraphs />
      </div>

      <h2 className={pagesStandardStyles.sectionHeader}>{lang.lineGraph.B2BHeader}</h2>
      <div className={styles.graphGrid}>
        <BusinessToBusinessGraphs />
      </div>
    </div>
  );
};

export default Graph;
